import React from 'react';

import styles from 'components/prequalification/ExistingAccountLocated/ExistingAccountLocated.module.scss';
import { maskEmail } from 'components/prequalification/RegistrationProcess/registrationProcess.utils';

interface ExistingAccountLocatedProps {
  mainContact?: { firstName: string; lastName: string; email: string };
}

const ExistingAccountLocated = ({ mainContact }: ExistingAccountLocatedProps) => {
  return (
    <>
      <div className={styles.text}>Existing Account Located</div>
      <div className={styles.text}>
        We can see that {mainContact?.firstName} {mainContact?.lastName}'s information has been previously submitted,
        but the account sign up and verification process was not completed.
      </div>
      <div className={styles.text}>
        If you wish to complete this process, click the button below to have an email sent to{' '}
        <a className={styles.boldText}>{maskEmail(mainContact?.email!)}</a> to allow you to complete the sign-up
        process.
      </div>
    </>
  );
};

export default ExistingAccountLocated;
